var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMlkLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 262.3 43.2",
    style: {
      enableBackground: "new 0 0 262.3 43.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.Arco_x0020_verde{fill:url(#SVGID_1_);stroke:#FFFFFF;stroke-width:0.25;stroke-miterlimit:1;}\n\t.st0{fill:#0D52A0;}\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -289.8018,
    y1: 318.6201,
    x2: -289.0947,
    y2: 317.9131
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1DA238"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9831,
    style: {
      stopColor: "#24391D"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2.5,4.3h12.6l4.8,19.6l4.6-19.6l12.6,0l0,28.9h-7.6L29.9,9L23,33.2h-7.2L9.2,8.8l0.2,24.4H2.5V4.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M41.4,4.3h8.1v23.2h13v5.7H41.4V4.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M65,4.3h8.1V17l9.2-12.7h9.5L81.9,17l10.8,16.2h-9.9l-9.6-15.4v15.4H65V4.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M95.4,4.3h8.4c3.9,0,8.4,0,11.6,3.8c2.6,3,3.6,7,3.6,10.9c0,6.2-2.6,10.1-4.8,11.8c-2.8,2.4-6.4,2.4-10.6,2.4 h-8.1V4.3z M99.4,29.9h3.9c2.8,0,5.6-0.2,7.6-1.6c3.7-2.8,3.8-7.5,3.8-9.2c0-1.1-0.1-6-2.8-9c-1.8-2-4.2-2.5-7.7-2.5h-4.8V29.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M125.4,23.8c-0.1,4.2,1.6,7.2,5.8,7.2c2.4,0,4.4-1.3,4.7-4.2h3.8c-0.1,1-0.3,2.6-1.7,4.2 c-0.9,1-2.9,2.7-6.9,2.7c-6.3,0-9.3-3.9-9.3-10.3c0-4,0.8-7.2,4-9.4c1.9-1.4,4.3-1.5,5.5-1.5c9,0,8.8,8,8.7,11.2H125.4z M136,21.2 c0-1.9-0.3-5.9-5-5.9c-2.4,0-5.4,1.5-5.5,5.9H136z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M143.8,4.4h3.8v28.8h-3.8V4.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M152.3,4.4h4.5v4.1h-4.5V4.4z M152.7,13.1h3.8v20.1h-3.8V13.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M159.2,13.1h4.2l6.4,15.9l6.2-15.9h4.2l-8.8,20.1h-3.8L159.2,13.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M184.6,23.8c-0.1,4.2,1.6,7.2,5.8,7.2c2.4,0,4.4-1.3,4.7-4.2h3.8c-0.1,1-0.3,2.6-1.7,4.2 c-0.9,1-2.9,2.7-6.9,2.7c-6.3,0-9.3-3.9-9.3-10.3c0-4,0.8-7.2,4-9.4c1.9-1.4,4.3-1.5,5.5-1.5c9,0,8.8,8,8.7,11.2H184.6z  M195.2,21.2c0-1.9-0.3-5.9-5-5.9c-2.4,0-5.4,1.5-5.5,5.9H195.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M203,17.2c0-1.4-0.1-2.8-0.2-4.1h3.8l0.1,3.9c0.7-2.8,3.1-3.7,4.8-4c1.1-0.2,2-0.1,2.6-0.1v3.7 c-0.2-0.1-0.4-0.1-0.7-0.2c-0.3,0-0.6,0-1.1,0c-4.4,0-5.5,2.6-5.5,6.1v10.7H203V17.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M216.5,4.4h4.5v4.1h-4.5V4.4z M216.9,13.1h3.8v20.1h-3.8V13.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M228.3,23.8c-0.1,4.2,1.6,7.2,5.8,7.2c2.4,0,4.4-1.3,4.7-4.2h3.8c-0.1,1-0.3,2.6-1.7,4.2 c-0.9,1-2.9,2.7-6.9,2.7c-6.3,0-9.3-3.9-9.3-10.3c0-4,0.8-7.2,4-9.4c1.9-1.4,4.3-1.5,5.5-1.5c9,0,8.8,8,8.7,11.2H228.3z  M238.9,21.2c0-1.9-0.3-5.9-5-5.9c-2.4,0-5.4,1.5-5.5,5.9H238.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M249.2,27.2c0,1.5,0.8,3.6,4.4,3.6c1.6,0,2.7-0.3,3.5-1.3c0.4-0.5,0.6-1.2,0.6-1.9c0-2-1.4-2.3-4.4-3 c-4.2-1-7.7-1.8-7.7-6c0-3.7,3.2-6.1,7.8-6.1c2.5,0,6,0.7,7.2,3.1c0.5,1.1,0.5,2.1,0.5,2.9h-3.8c0.1-3-2.5-3.3-3.9-3.3 c-0.6,0-4.1,0-4.1,2.9c0,1.8,1.8,2.3,2.8,2.6c5.6,1.3,6.8,1.6,8,2.8c1.1,1,1.5,2.4,1.5,3.7c0,2.2-1.2,4.2-2.7,5.1 c-1.8,1.1-3.9,1.4-6,1.4c-4.1,0-7.9-1.7-7.8-6.5H249.2z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMlkLogo);
export default __webpack_public_path__ + "static/media/mlk-logo.863995163634029372b02a31cf0f080a.svg";
export { ForwardRef as ReactComponent };